import classNames from 'classnames';
import React from 'react';
import css from './CustomActiveStoreFilter.module.css';

function CustomActiveStoreFilter(props) {
  const { className, labelMaxWidth = null, reset, label } = props;

  const labelStyles = true ? css.labelSelected : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      className={classNames(labelStyles, labelMaxWidthStyles, className)}
      style={labelMaxWidthMaybe}
      onClick={reset}
    >
      <span className={css.labelText}>{label}</span>
      <span className={css.resetIcon}>X</span>
    </button>
  );
}

export default CustomActiveStoreFilter;
